import React from 'react'
import { Result, Button } from 'antd'
import { useNavigate } from "react-router-dom"

import { useStore } from '@/store'
import { observer } from 'mobx-react-lite'
import { toJS } from 'mobx'

const StepThree = () => {
    const { RegisterStore } = useStore()
    //路由跳转
    const navigate = useNavigate()
    return (
        <>
            {
                toJS(RegisterStore.isStatus === 200) ? (<Result
                    status="success"
                    title="注册成功"
                    // subTitle="用户名:永发合作社"
                    extra={[
                        <Button type="primary" key="login" onClick={() => { navigate("/login") }}>
                            去登陆
                        </Button>
                    ]}
                />) : (<Result
                    status="error"
                    title="注册失败"
                />)

            }
        </>
    )
}

export default observer(StepThree)